<template>
  <v-container fluid>
    <PageTitle title="Pages" />

    <ApiDataTable
      ref="dataTable"
      data-api="pages"
      :can-insert="true"
      :can-update="true"
      :can-delete="true"
      :row-buttons="[
        { title: 'Preview', icon: 'mdi-magnify' },
        { title: 'Design', icon: 'mdi-monitor-edit' },
        { title: 'Copy', icon: 'mdi-content-copy' },
      ]"
      @row-button-click="rowButtonClick"
    />
  </v-container>
</template>

<script>
import server from "../../services/server";
import ApiDataTable from "../ui/shared/ApiDataTable.vue";
import PageTitle from "../ui/shared/PageTitle.vue";

export default {
  name: "Pages",
  
  components: { ApiDataTable, PageTitle },

  methods: {
    rowButtonClick({ item, button }) {
      if (button.title == "Copy") {
        server
          .get("pages/" + item.pageId + "/copy")
          .then(() => this.$refs.dataTable.refresh())
          .catch((err) => alert(err));
      } else if (button.title == "Preview") {
        this.$router.push("/pages/" + item.name);
      } else {
        this.$router.push("/admin/pages/" + item.pageId);
      }
    },
  },
};
</script>